// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { SimulationAsset, SimulationAssetT, verifySimulationAsset } from "./simulation-asset";

export class SimulationAssetList implements flatbuffers.IUnpackableObject<SimulationAssetListT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SimulationAssetList {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSimulationAssetList(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationAssetList,
  ): SimulationAssetList {
    return (obj || new SimulationAssetList()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsSimulationAssetList(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationAssetList,
  ): SimulationAssetList {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SimulationAssetList()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  assets(index: number, obj?: SimulationAsset): SimulationAsset | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new SimulationAsset()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  assetsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startSimulationAssetList(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addAssets(builder: flatbuffers.Builder, assetsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, assetsOffset, 0);
  }

  static createAssetsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startAssetsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endSimulationAssetList(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createSimulationAssetList(
    builder: flatbuffers.Builder,
    assetsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    SimulationAssetList.startSimulationAssetList(builder);
    SimulationAssetList.addAssets(builder, assetsOffset);
    return SimulationAssetList.endSimulationAssetList(builder);
  }

  unpack(): SimulationAssetListT {
    return new SimulationAssetListT(
      this.bb!.createObjList<SimulationAsset, SimulationAssetT>(
        this.assets.bind(this),
        this.assetsLength(),
      ),
    );
  }

  unpackTo(_o: SimulationAssetListT): void {
    _o.assets = this.bb!.createObjList<SimulationAsset, SimulationAssetT>(
      this.assets.bind(this),
      this.assetsLength(),
    );
  }

  unpackFields(...fields: string[]): SimulationAssetListT {
    const t = new SimulationAssetListT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("assets")) {
      t.assets = this.bb!.createObjList<SimulationAsset, SimulationAssetT>(
        this.assets.bind(this),
        this.assetsLength(),
      );
    }
    return t;
  }
}

export class SimulationAssetListT implements flatbuffers.IGeneratedObject {
  constructor(public assets: SimulationAssetT[] = []) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const assets = SimulationAssetList.createAssetsVector(
      builder,
      builder.createObjectOffsetList(this.assets),
    );

    return SimulationAssetList.createSimulationAssetList(builder, assets);
  }

  clone(): SimulationAssetListT {
    const obj = new SimulationAssetListT();
    obj.assets = this.assets.map((e) => e.clone());
    return obj;
  }

  equals(other: SimulationAssetListT): boolean {
    if (this.assets.length !== other.assets.length) return false;
    for (let i = 0; i < this.assets.length; i++) {
      const a = this.assets[i];
      const b = other.assets[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifySimulationAssetList(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifySimulationAsset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
